/* Lunarioa — interacciones propias. Vanilla, sin librerias externas. */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- Entradas al hacer scroll ------------------------------------------ */
  function initReveals() {
    var elementos = document.querySelectorAll('.lun-reveal:not(.lun-visible)');
    if (!elementos.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      elementos.forEach(function (el) { el.classList.add('lun-visible'); });
      return;
    }
    var obs = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('lun-visible');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    elementos.forEach(function (el) { obs.observe(el); });
  }

  /* --- Preguntas frecuentes ---------------------------------------------- */
  function initFaq() {
    var items = document.querySelectorAll('.lun-faq__item');
    if (!items.length) return;
    items.forEach(function (item) {
      var boton = item.querySelector('.lun-faq__boton');
      var panel = item.querySelector('.lun-faq__panel');
      if (!boton || !panel) return;
      if (boton.dataset.lunListo === '1') return;
      boton.dataset.lunListo = '1';
      boton.setAttribute('aria-expanded', 'false');
      boton.addEventListener('click', function () {
        var abierto = item.classList.contains('lun-abierto');
        var padre = item.closest('.lun-faq__lista');
        if (padre) {
          padre.querySelectorAll('.lun-faq__item.lun-abierto').forEach(function (otro) {
            if (otro === item) return;
            otro.classList.remove('lun-abierto');
            var p = otro.querySelector('.lun-faq__panel');
            var b = otro.querySelector('.lun-faq__boton');
            if (p) p.style.maxHeight = null;
            if (b) b.setAttribute('aria-expanded', 'false');
          });
        }
        item.classList.toggle('lun-abierto', !abierto);
        boton.setAttribute('aria-expanded', String(!abierto));
        panel.style.maxHeight = abierto ? null : panel.scrollHeight + 'px';
      });
    });
  }

  /* --- Galeria de la ficha de producto ----------------------------------- */
  function initGaleria() {
    var galerias = document.querySelectorAll('[data-lun-galeria]');
    if (!galerias.length) return;
    galerias.forEach(function (galeria) {
      var principal = galeria.querySelector('[data-lun-principal]');
      var minis = galeria.querySelectorAll('[data-lun-mini]');
      if (!principal || !minis.length) return;
      minis.forEach(function (mini) {
        if (mini.dataset.lunListo === '1') return;
        mini.dataset.lunListo = '1';
        mini.addEventListener('click', function () {
          var src = mini.getAttribute('data-lun-src');
          if (!src) return;
          principal.src = src;
          principal.srcset = '';
          galeria.querySelectorAll('.lun-mini').forEach(function (m) { m.classList.remove('lun-activa'); });
          mini.classList.add('lun-activa');
        });
      });
    });
  }

  /* --- Cantidad ----------------------------------------------------------- */
  function initCantidad() {
    document.querySelectorAll('[data-lun-cant]').forEach(function (caja) {
      if (caja.dataset.lunListo === '1') return;
      caja.dataset.lunListo = '1';
      var campo = caja.querySelector('input');
      caja.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          if (!campo) return;
          var v = parseInt(campo.value, 10) || 1;
          v += (b.getAttribute('data-lun-paso') === '+' ? 1 : -1);
          campo.value = String(Math.max(1, v));
        });
      });
    });
  }

  /* --- Selector de variantes --------------------------------------------- */
  function initVariantes() {
    var bloques = document.querySelectorAll('[data-lun-variantes]');
    if (!bloques.length) return;

    bloques.forEach(function (bloque) {
      if (bloque.dataset.lunListo === '1') return;
      bloque.dataset.lunListo = '1';

      var datos = bloque.querySelector('[data-lun-json]');
      if (!datos) return;
      var variantes;
      try { variantes = JSON.parse(datos.textContent); } catch (e) { return; }
      if (!variantes || !variantes.length) return;

      var campoId  = bloque.querySelector('[data-lun-id]');
      var precio   = bloque.querySelector('[data-lun-precio]');
      var comparar = bloque.querySelector('[data-lun-comparar]');
      var boton    = bloque.querySelector('[data-lun-anadir]');
      var aviso    = bloque.querySelector('[data-lun-agotado]');
      var textoAgotado = boton ? (boton.getAttribute('data-lun-texto-agotado') || 'Agotado') : '';
      var textoNormal  = boton ? (boton.getAttribute('data-lun-texto-normal') || boton.textContent.trim()) : '';

      function formatea(centimos) {
        var c = Math.round(centimos || 0);
        var enteros = Math.floor(c / 100);
        var dec = ('0' + (c % 100)).slice(-2);
        var miles = String(enteros).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        return miles + ',' + dec + '\u00A0€';
      }

      function seleccionadas() {
        return Array.prototype.map.call(
          bloque.querySelectorAll('[data-lun-opcion]'),
          function (grupo) {
            var activo = grupo.querySelector('.lun-opcion__valor.lun-sel');
            return activo ? activo.getAttribute('data-lun-valor') : null;
          }
        );
      }

      // El stock que llega en el HTML no es fiable en las vistas previas de Shopify:
      // a veces dice "agotado" con existencias de sobra. La fuente buena es la propia
      // API de la tienda (/products/handle.js), así que la consultamos al cargar.
      // Hasta que responda, NO bloqueamos nada: el carrito de Shopify rechazaría de
      // todas formas cualquier cosa que no haya de verdad.
      var stockReal = null;
      var urlProducto = bloque.getAttribute('data-lun-url');
      if (urlProducto) {
        fetch(urlProducto + '.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (p) {
            if (!p || !p.variants) return;
            stockReal = {};
            p.variants.forEach(function (v) { stockReal[v.id] = v.available !== false; });
            actualiza();
          })
          .catch(function () { /* si falla, todo sigue comprable */ });
      }

      function estaAgotada(v) {
        if (stockReal && Object.prototype.hasOwnProperty.call(stockReal, v.id)) {
          return stockReal[v.id] === false;
        }
        return false;
      }

      var ficha = bloque.closest('.lun-pdp') || document;
      var galeria = ficha.querySelector('[data-lun-galeria]');
      var principal = galeria ? galeria.querySelector('[data-lun-principal]') : null;

      function mismaFoto(a, b) {
        if (!a || !b) return false;
        var limpia = function (u) { return String(u).split('?')[0].replace(/_\d+x\d*(?=\.[a-z]+$)/i, ''); };
        return limpia(a) === limpia(b);
      }

      function muestraFoto(url) {
        if (!principal || !url) return;
        principal.src = url;
        principal.srcset = '';
        if (!galeria) return;
        galeria.querySelectorAll('[data-lun-mini]').forEach(function (m) {
          m.classList.toggle('lun-activa', mismaFoto(m.getAttribute('data-lun-src'), url));
        });
      }

      function actualiza() {
        var elegidas = seleccionadas();
        var v = variantes.find(function (item) {
          return elegidas.every(function (val, i) {
            return val === null || item.opciones[i] === val;
          });
        });
        if (!v) { v = variantes.find(function (item) { return item.disponible; }) || variantes[0]; }
        if (!v) return;

        if (v.imagen) muestraFoto(v.imagen);

        if (campoId) campoId.value = v.id;
        if (precio) precio.textContent = formatea(v.precio);
        if (comparar) {
          if (v.comparar && v.comparar > v.precio) {
            comparar.textContent = formatea(v.comparar);
            comparar.hidden = false;
          } else {
            comparar.hidden = true;
          }
        }
        if (boton) {
          var agotada = estaAgotada(v);
          boton.disabled = agotada;
          boton.textContent = agotada ? textoAgotado : textoNormal;
        }
        if (aviso) aviso.hidden = !estaAgotada(v);

        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
      }

      bloque.querySelectorAll('.lun-opcion__valor').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var grupo = btn.closest('[data-lun-opcion]');
          if (!grupo) return;
          grupo.querySelectorAll('.lun-opcion__valor').forEach(function (o) { o.classList.remove('lun-sel'); });
          btn.classList.add('lun-sel');
          actualiza();
        });
      });

      actualiza();
    });
  }

  function iniciar() {
    initReveals();
    initFaq();
    initGaleria();
    initCantidad();
    initVariantes();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }

  /* El editor de Shopify recarga secciones sueltas: re-inicializa. */
  document.addEventListener('shopify:section:load', iniciar);
})();
